<script>
  import { Input, FileSelect, Select, Button } from "../../components/ui";

  export let model;

  let styles = [];
</script>

<div>
  <div>
    <h2>Page Style</h2>
    <div>
      <div class="flex flex-row">
        <div class="w-1/3" on:click={(model.pageStyle = 0)}>
          <div style="background-color:{model.colors.default}">
            <svg class="w-full h-full" viewBox="0 0 99 77" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0
                5.29543H99V11.0523H67V52.2471H83.0222H99V77H0V5.29543ZM8.86601
                7.55218L8.86778 7.55395C9.03686 7.72482 9.14426 7.94757 9.17289
                8.18679C9.20152 8.42602 9.14974 8.66799 9.0258 8.87426C8.90185
                9.08053 8.71285 9.23925 8.48882 9.32521C8.2648 9.41116 8.01861
                9.4194 7.7894 9.34862C7.7701 9.3427 7.74949 9.3427 7.7302
                9.34862C7.50097 9.41943 7.25476 9.41119 7.03072 9.32525C6.80668
                9.23931 6.61766 9.08058 6.49371 8.87429C6.36976 8.66801 6.31799
                8.42602 6.34663 8.18678C6.37527 7.94754 6.48268 7.72479 6.65178
                7.55393L6.6536 7.55215L6.65393 7.55176L7.7598 6.44063L8.86568
                7.55179L8.86601 7.55218ZM7.0346 8.30557C7.03751 8.29851 7.04178
                8.29208 7.04716 8.28668L7.42674 7.88227C7.43052 7.8791 7.43528
                7.87737 7.4402 7.87737C7.44512 7.87737 7.44988 7.8791 7.45366
                7.88227C7.45744 7.88543 7.45999 7.88983 7.46087 7.8947C7.46175
                7.89956 7.46091 7.90457 7.45848 7.90887C7.31107 8.17685 7.43775
                8.56174 7.64919 8.77413L7.65021 8.77518C7.67936 8.80419 7.71874
                8.82048 7.75977 8.82049C7.8008 8.8205 7.84019 8.80425 7.86936
                8.77525L7.87047 8.77413C8.08184 8.56174 8.20858 8.17681 8.06119
                7.90882C8.05876 7.90451 8.05792 7.8995 8.0588 7.89464C8.05969
                7.88978 8.06223 7.88537 8.06601 7.88222C8.06978 7.87905 8.07455
                7.87731 8.07946 7.87731C8.08439 7.87731 8.08915 7.87905 8.09293
                7.88222L8.47243 8.28666C8.47783 8.29207 8.48211 8.29848 8.48504
                8.30556C8.48797 8.31263 8.48948 8.32021 8.48948 8.32785C8.48748
                8.52396 8.43229 8.71581 8.32985 8.88276C8.32753 8.88654 8.32645
                8.89098 8.32678 8.89541C8.32711 8.89986 8.32884 8.90408 8.33169
                8.90748C8.33457 8.91086 8.33842 8.91327 8.34272 8.91433C8.34702
                8.9154 8.35154 8.91507 8.35566 8.91339C8.43264 8.88085 8.50257
                8.83355 8.56156 8.77413C8.68245 8.65266 8.75042 8.48794 8.75052
                8.31616C8.75064 8.14437 8.68287 7.97956 8.56212 7.85795L7.7598
                7.05185L6.95744 7.85795C6.83672 7.97958 6.76897 8.14438 6.76908
                8.31616C6.76919 8.48794 6.83715 8.65266 6.95803 8.77413C7.01701
                8.83355 7.08696 8.88085 7.16395 8.91339C7.16805 8.91507 7.17258
                8.9154 7.17688 8.91433C7.18118 8.91327 7.18504 8.91088 7.1879
                8.90748C7.19076 8.90408 7.19248 8.89986 7.19281 8.89543C7.19314
                8.89099 7.19206 8.88656 7.18974 8.88277C7.08732 8.71581 7.03216
                8.52396 7.03019 8.32785C7.03019 8.32021 7.03169 8.31263 7.0346
                8.30557ZM7.47829 60.7697C7.43183 60.7697 7.38727 60.7512 7.35441
                60.7182C7.32156 60.6852 7.3031 60.6404 7.3031
                60.5937V60.0656H6.60233C6.50941 60.0656 6.42029 60.0285 6.35458
                59.9625C6.28887 59.8965 6.25195 59.807 6.25195
                59.7136V57.6013C6.25195 57.4059 6.40963 57.2493 6.60233
                57.2493H9.40539C9.49831 57.2493 9.58744 57.2864 9.65315
                57.3524C9.71885 57.4184 9.75577 57.5079 9.75577
                57.6013V59.7136C9.75577 59.807 9.71885 59.8965 9.65315
                59.9625C9.58744 60.0285 9.49831 60.0656 9.40539
                60.0656H8.33672L7.68852 60.7187C7.65348 60.7521 7.60968 60.7697
                7.56588 60.7697H7.47829ZM8.87982
                58.8335V58.4814H8.52943V58.8335H8.87982ZM8.17905
                58.8335V58.4814H7.82867V58.8335H8.17905ZM7.47829
                58.8335V58.4814H7.12791V58.8335H7.47829ZM38.1407
                58.4813H37.1725V57.5132L38.1407 58.4813ZM37.3485
                57.2491H35.9401C35.7447 57.2491 35.588 57.4058 35.588
                57.6012V60.4176C35.588 60.6112 35.7447 60.7696 35.9401
                60.7696H38.0527C38.1461 60.7696 38.2356 60.7325 38.3017
                60.6665C38.3677 60.6005 38.4048 60.5109 38.4048
                60.4176V58.3053L37.3485 57.2491ZM37.5246
                59.7135V60.0655H35.9401V59.7135H37.5246ZM38.0527
                59.0094V59.3614H35.9401V59.0094H38.0527ZM66.6069 57.2491C65.6433
                57.2491 64.855 58.0412 64.855 59.0094C64.855 59.9775 65.6433
                60.7696 66.6069 60.7696C67.5704 60.7696 68.3588 59.9775 68.3588
                59.0094C68.3588 58.0412 67.5704 57.2491 66.6069 57.2491ZM66.2565
                59.8895L65.3806 59.0094L65.6276 58.7612L66.2565 59.3913L67.5862
                58.0553L67.8332 58.3053L66.2565 59.8895ZM84
                6.02852H94V10.0475H84V6.02852ZM42 41H32V45H42V41Z"
                fill="white" />
              <path
                d="M98.9903 1.95582H0V0.216042C0 0.108527 0.087559 0.0205612
                0.194575 0.0205612H98.8054C98.9124 0.0205612 99 0.108527 99
                0.216042V1.95582H98.9903Z"
                fill="#E6E6E6" />
              <path
                d="M97.4629 0.938484L97.21 1.20238L97.0738
                1.05577V1.46628H97.4824L97.3365 1.31967L97.5894 1.06555L97.4629
                0.938484Z"
                fill="#333333" />
              <path
                d="M97.6282 1.02642L97.8811 0.772298L98.0173
                0.918909V0.5084H97.6185L97.7547 0.65501L97.5017 0.909135L97.6282
                1.02642Z"
                fill="#333333" />
              <path
                d="M0 1.96458H5.03951L6.09021 0.0684181C6.09994 0.0488701 6.1194
                0.0390961 6.12913 0.0390961H16.3249C16.3443 0.0390961 16.3541
                0.0488701 16.3638 0.0586441L17.434
                1.9548H98.9806V1.92548H17.4632L16.393 0.0390961C16.3833 0.019548
                16.3541 0 16.3346 0H6.12913C6.09994 0 6.08048 0.00977402 6.07076
                0.0390961L5.02005 1.94503H0V1.96458ZM0
                5.36594H98.9903V5.33661H0V5.36594Z"
                fill="#333333" />
              <path
                d="M17.4534 1.95699L16.3833 0.0608315C16.3735 0.0412834 16.3541
                0.0315094 16.3346 0.0315094H6.12913C6.10967 0.0315094 6.09021
                0.0412834 6.08048 0.0608315L5.02978
                1.95699H0V5.35835H98.9903V1.95699H17.4534Z"
                fill="#F2F2F2" />
              <path
                d="M5.20486 3.60664C5.17567 3.60664 5.15621 3.62619 5.15621
                3.65551C5.15621 3.75325 5.1173 3.84122 5.0492 3.90964C4.90327
                4.05625 4.6795 4.05625 4.53357 3.90964C4.38764 3.76303 4.38764
                3.53823 4.53357 3.39162C4.66005 3.26455 4.87408 3.25478 5.01028
                3.36229L4.90327 3.46981H5.1854V3.18636L5.07838 3.29388C4.89354
                3.13749 4.62113 3.14727 4.45574 3.3232C4.2709 3.5089 4.2709
                3.80212 4.45574 3.97806C4.5433 4.06602 4.66978 4.11489 4.78652
                4.11489C4.90327 4.11489 5.02001 4.06602 5.1173 3.97806C5.20486
                3.89009 5.2535 3.7728 5.2535 3.64574C5.26323 3.63597 5.23405
                3.60664 5.20486 3.60664Z"
                fill="#333333" />
              <path
                d="M3.10358 3.21552L3.01602 3.30348L3.31761
                3.5967H2.53931V3.72376H3.31761L3.01602 4.01698L3.10358
                4.10495L3.54137 3.65535L3.10358 3.21552Z"
                fill="#B3B3B3" />
              <path
                d="M1.49819 3.30517L1.41063 3.2172L0.972839 3.65703L1.41063
                4.10664L1.49819 4.01867L1.20633
                3.72545H1.9749V3.59839H1.20633L1.49819 3.30517Z"
                fill="#333333" />
              <path
                d="M95.4808 2.74869H6.46248C6.34573 2.74869 6.24844 2.84643
                6.24844 2.96372V4.37117C6.24844 4.48846 6.34573 4.5862 6.46248
                4.5862H95.4808C95.5975 4.5862 95.6948 4.48846 95.6948
                4.37117V2.95394C95.6948 2.83665 95.5975 2.74869 95.4808 2.74869Z"
                fill="white" />
              <path
                d="M95.4783 4.59377H6.45997C6.33349 4.59377 6.23621 4.50581
                6.23621 4.39829V2.93219C6.23621 2.82468 6.33349 2.73671 6.45997
                2.73671H95.4783C95.6047 2.73671 95.702 2.82468 95.702
                2.93219V4.39829C95.702 4.50581 95.6047 4.59377 95.4783
                4.59377ZM6.45997 2.75626C6.35295 2.75626 6.25566 2.83445 6.25566
                2.93219V4.39829C6.25566 4.49603 6.34322 4.57422 6.45997
                4.57422H95.4783C95.5853 4.57422 95.6826 4.49603 95.6826
                4.39829V2.93219C95.6826 2.83445 95.595 2.75626 95.4783
                2.75626H6.45997V2.75626Z"
                fill="#333333" />
              <path
                d="M97.9495 3.73293H96.7528C96.7139 3.73293 96.675 3.70375
                96.675 3.65511C96.675 3.6162 96.7042 3.57729 96.7528
                3.57729H97.9495C97.9884 3.57729 98.0273 3.60647 98.0273
                3.65511C98.0176 3.70375 97.9884 3.73293 97.9495 3.73293Z"
                fill="#333333" />
              <path
                d="M97.9504 3.34199H96.7537C96.7148 3.34199 96.6759 3.31281
                96.6759 3.26417C96.6759 3.22526 96.7051 3.18635 96.7537
                3.18635H97.9504C97.9893 3.18635 98.0282 3.21553 98.0282
                3.26417C98.0185 3.31281 97.9893 3.34199 97.9504 3.34199Z"
                fill="#333333" />
              <path
                d="M97.9495 4.12394H96.7528C96.7139 4.12394 96.675 4.09476
                96.675 4.04612C96.675 4.00721 96.7042 3.9683 96.7528
                3.9683H97.9495C97.9884 3.9683 98.0273 3.99748 98.0273
                4.04612C98.0176 4.09476 97.9884 4.12394 97.9495 4.12394Z"
                fill="#333333" />
              <path
                d="M16.0916 1.47588C16.3066 1.47588 16.4808 1.30084 16.4808
                1.08492C16.4808 0.868994 16.3066 0.693954 16.0916
                0.693954C15.8767 0.693954 15.7025 0.868994 15.7025
                1.08492C15.7025 1.30084 15.8767 1.47588 16.0916 1.47588Z"
                fill="#B3B3B3" />
              <path
                d="M4.12499 1.37813C4.33991 1.37813 4.51414 1.20309 4.51414
                0.987167C4.51414 0.771246 4.33991 0.596207 4.12499
                0.596207C3.91007 0.596207 3.73584 0.771246 3.73584
                0.987167C3.73584 1.20309 3.91007 1.37813 4.12499 1.37813Z"
                fill="#32A854" />
              <path
                d="M2.76299 1.37813C2.97791 1.37813 3.15214 1.20309 3.15214
                0.987167C3.15214 0.771246 2.97791 0.596207 2.76299
                0.596207C2.54807 0.596207 2.37384 0.771246 2.37384
                0.987167C2.37384 1.20309 2.54807 1.37813 2.76299 1.37813Z"
                fill="#FABC05" />
              <path
                d="M1.40093 1.37813C1.61585 1.37813 1.79008 1.20309 1.79008
                0.987167C1.79008 0.771246 1.61585 0.596207 1.40093
                0.596207C1.18601 0.596207 1.01178 0.771246 1.01178
                0.987167C1.01178 1.20309 1.18601 1.37813 1.40093 1.37813Z"
                fill="#EA4235" />
              <path
                d="M18.0469 0.938212H17.7648V0.654766C17.7648 0.625444 17.7453
                0.605896 17.7162 0.605896C17.687 0.605896 17.6675 0.625444
                17.6675 0.654766V0.938212H17.3854C17.3562 0.938212 17.3367
                0.957761 17.3367 0.987083C17.3367 1.0164 17.3562 1.03595 17.3854
                1.03595H17.6675V1.3194C17.6675 1.34872 17.687 1.36827 17.7162
                1.36827C17.7453 1.36827 17.7648 1.34872 17.7648
                1.3194V1.03595H18.0469C18.0761 1.03595 18.0956 1.0164 18.0956
                0.987083C18.0956 0.957761 18.0761 0.938212 18.0469 0.938212Z"
                fill="#333333" />
              <rect
                x="6.4812"
                y="63.2603"
                width="22.5065"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6.4812"
                y="65.6934"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6.4812"
                y="68.1265"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6.4812"
                y="70.5596"
                width="18.3043"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="63.1887"
                width="22.5065"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="65.6218"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="68.0547"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="70.488"
                width="18.3043"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="63.1887"
                width="22.5065"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="65.6218"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="68.0547"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="70.488"
                width="18.3043"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6"
                y="41.1948"
                width="26"
                height="4.01901"
                fill="white" />
              <rect
                x="75.236"
                y="7.08477"
                width="5.12806"
                height="1.71747"
                fill="#C4C4C4" />
              <rect
                x="66.6179"
                y="7.08477"
                width="5.12806"
                height="1.71747"
                fill="#C4C4C4" />
              <rect
                x="58"
                y="7.08477"
                width="5.12806"
                height="1.71747"
                fill="#C4C4C4" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M67 11.0523H0V52.2471H33.5465H67V11.0523ZM42 41H32V45H42V41Z"
                fill="url(#paint0_linear)" />
              <rect x="6" y="41" width="26" height="4" fill="white" />
              <rect x="6" y="23" width="37" height="3" fill="#242424" />
              <rect x="6" y="28" width="19" height="3" fill="#242424" />
              <rect x="6" y="35" width="38" height="1" fill="#9C9B9B" />
              <rect x="6" y="37" width="31" height="1" fill="#9C9B9B" />
              <path
                d="M55.7394 45.1234C54.3833 45.1234 53.0269 44.9436 51.7085
                44.5949H72.8397H93.9653C92.6523 44.9436 91.2948 45.1234 89.9311
                45.1234H72.8397H55.7394Z"
                fill="white"
                stroke="black"
                stroke-width="0.2" />
              <path
                d="M90.6912
                44.1394V44.1925H90.5321H55.1379H54.9787V44.1394H90.6912Z"
                fill="black" />
              <rect
                x="55.7421"
                y="21.3173"
                width="34.1152"
                height="21.69"
                fill="white" />
              <path
                d="M89.8298
                42.9449H89.9298V42.8449V21.5223V21.4223H89.8298H55.8403H55.7403V21.5223V42.8449V42.9449H55.8403H89.8298ZM56.0351
                20.208H89.6349C90.0895 20.208 90.465 20.5936 90.465
                21.0786V44.1159H90.403H90.3222H90.2416H90.161H90.0807H90.0004H89.9203H89.8403H89.7605H89.6808H89.6012H89.5218H89.4424H89.3633H89.2842H89.2053H89.1265H89.0479H88.9693H88.8909H88.8127H88.7345H88.6565H88.5786H88.5008H88.4232H88.3457H88.2683H88.191H88.1139H88.0368H87.9599H87.8832H87.8065H87.73H87.6535H87.5772H87.5011H87.425H87.349H87.2732H87.1975H87.1219H87.0464H86.971H86.8958H86.8207H86.7456H86.6707H86.5959H86.5212H86.4466H86.3722H86.2978H86.2236H86.1494H86.0754H86.0015H85.9276H85.8539H85.7803H85.7068H85.6334H85.5601H85.487H85.4139H85.3409H85.268H85.1952H85.1226H85.05H84.9775H84.9051H84.8329H84.7607H84.6886H84.6166H84.5447H84.473H84.4013H84.3297H84.2582H84.1867H84.1154H84.0442H83.9731H83.902H83.8311H83.7602H83.6895H83.6188H83.5482H83.4777H83.4073H83.337H83.2667H83.1966H83.1265H83.0566H82.9867H82.9168H82.8471H82.7775H82.7079H82.6384H82.5691H82.4997H82.4305H82.3614H82.2923H82.2233H82.1544H82.0855H82.0168H81.9481H81.8795H81.8109H81.7425H81.6741H81.6058H81.5375H81.4694H81.4013H81.3333H81.2653H81.1974H81.1296H81.0619H80.9942H80.9266H80.8591H80.7916H80.7242H80.6569H80.5896H80.5224H80.4553H80.3882H80.3212H80.2543H80.1874H80.1206H80.0538H79.9871H79.9205H79.8539H79.7874H79.7209H79.6545H79.5882H79.5219H79.4557H79.3895H79.3234H79.2573H79.1913H79.1253H79.0594H78.9936H78.9278H78.8621H78.7964H78.7307H78.6651H78.5996H78.5341H78.4686H78.4032H78.3379H78.2726H78.2073H78.1421H78.0769H78.0118H77.9467H77.8817H77.8167H77.7518H77.6869H77.622H77.5572H77.4924H77.4276H77.3629H77.2983H77.2336H77.169H77.1045H77.04H76.9755H76.911H76.8466H76.7822H76.7179H76.6536H76.5893H76.5251H76.4608H76.3967H76.3325H76.2684H76.2043H76.1402H76.0762H76.0122H75.9482H75.8842H75.8203H75.7564H75.6925H75.6287H75.5648H75.501H75.4372H75.3735H75.3097H75.246H75.1823H75.1186H75.055H74.9913H74.9277H74.8641H74.8005H74.737H74.6734H74.6099H74.5463H74.4828H74.4193H74.3559H74.2924H74.2289H74.1655H74.1021H74.0386H73.9752H73.9118H73.8484H73.7851H73.7217H73.6583H73.595H73.5316H73.4683H73.4049H73.3416H73.2783H73.2149H73.1516H73.0883H73.025H72.9616H72.8983H72.835H72.7717H72.7084H72.6451H72.5817H72.5184H72.4551H72.3918H72.3284H72.2651H72.2018H72.1384H72.0751H72.0117H71.9483H71.885H71.8216H71.7582H71.6948H71.6314H71.568H71.5045H71.4411H71.3776H71.3142H71.2507H71.1872H71.1237H71.0602H70.9966H70.9331H70.8695H70.8059H70.7423H70.6787H70.615H70.5514H70.4877H70.424H70.3603H70.2966H70.2328H70.169H70.1052H70.0414H69.9775H69.9136H69.8497H69.7858H69.7218H69.6579H69.5938H69.5298H69.4657H69.4016H69.3375H69.2734H69.2092H69.145H69.0807H69.0164H68.9521H68.8878H68.8234H68.759H68.6945H68.6301H68.5655H68.501H68.4364H68.3718H68.3071H68.2424H68.1776H68.1129H68.048H67.9832H67.9183H67.8533H67.7883H67.7233H67.6582H67.5931H67.5279H67.4627H67.3974H67.3321H67.2668H67.2014H67.1359H67.0704H67.0049H66.9393H66.8737H66.808H66.7422H66.6764H66.6106H66.5447H66.4787H66.4127H66.3466H66.2805H66.2144H66.1481H66.0818H66.0155H65.9491H65.8826H65.8161H65.7495H65.6829H65.6162H65.5494H65.4826H65.4157H65.3488H65.2818H65.2147H65.1476H65.0804H65.0131H64.9458H64.8784H64.8109H64.7434H64.6758H64.6081H64.5404H64.4726H64.4047H64.3368H64.2687H64.2006H64.1325H64.0642H63.9959H63.9275H63.8591H63.7906H63.7219H63.6533H63.5845H63.5157H63.4467H63.3777H63.3087H63.2395H63.1703H63.101H63.0316H62.9621H62.8925H62.8229H62.7532H62.6834H62.6135H62.5435H62.4734H62.4033H62.333H62.2627H62.1923H62.1218H62.0512H61.9806H61.9098H61.8389H61.768H61.6969H61.6258H61.5546H61.4833H61.4119H61.3404H61.2688H61.1971H61.1253H61.0534H60.9814H60.9093H60.8372H60.7649H60.6925H60.62H60.5475H60.4748H60.402H60.3291H60.2561H60.1831H60.1099H60.0366H59.9632H59.8897H59.8161H59.7424H59.6686H59.5946H59.5206H59.4465H59.3722H59.2978H59.2234H59.1488H59.0741H58.9993H58.9244H58.8494H58.7742H58.699H58.6236H58.5481H58.4725H58.3968H58.321H58.245H58.169H58.0928H58.0165H57.9401H57.8635H57.7869H57.7101H57.6332H57.5562H57.479H57.4017H57.3244H57.2468H57.1692H57.0914H57.0135H56.9355H56.8574H56.7791H56.7007H56.6222H56.5435H56.4647H56.3858H56.3068H56.2276H56.1483H56.0688H55.9893H55.9095H55.8297H55.7497H55.6696H55.5894H55.509H55.4285H55.3478H55.267H55.205V21.0786C55.205
                20.5936 55.5806 20.208 56.0351 20.208Z"
                fill="white"
                stroke="black"
                stroke-width="0.2" />
              <rect
                x="51.1"
                y="44.1833"
                width="43.4414"
                height="0.365791"
                fill="white"
                stroke="black"
                stroke-width="0.2" />
              <defs>
                <linearGradient
                  id="paint0_linear"
                  x1="-3.52194e-07"
                  y1="31.1473"
                  x2="66"
                  y2="31.1473"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#E9E9E9" />
                  <stop offset="1" stop-color="white" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <p>Clean Light</p>
        </div>
        <div class="w-1/3 mx-2" on:click={(model.pageStyle = 1)}>
          <div style="background-color:{model.colors.default}">

            <svg class="w-full h-full" viewBox="0 0 99 77" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0
                5.29543H99V11.0523H67V52.2471H83.0222H99V77H0V5.29543ZM8.86601
                7.55218L8.86778 7.55396C9.03686 7.72482 9.14426 7.94757 9.17289
                8.18679C9.20152 8.42602 9.14974 8.668 9.0258 8.87427C8.90185
                9.08053 8.71285 9.23926 8.48882 9.32521C8.2648 9.41116 8.01861
                9.4194 7.7894 9.34862C7.7701 9.3427 7.74949 9.3427 7.7302
                9.34862C7.50097 9.41943 7.25476 9.41119 7.03072 9.32525C6.80668
                9.23931 6.61766 9.08058 6.49371 8.87429C6.36976 8.66801 6.31799
                8.42602 6.34663 8.18678C6.37527 7.94754 6.48268 7.72479 6.65178
                7.55393L6.6536 7.55215L6.65393 7.55177L7.7598 6.44063L8.86568
                7.55179L8.86601 7.55218ZM7.0346 8.30557C7.03751 8.29851 7.04178
                8.29209 7.04716 8.28668L7.42674 7.88228C7.43052 7.8791 7.43528
                7.87737 7.4402 7.87737C7.44512 7.87737 7.44988 7.8791 7.45366
                7.88228C7.45744 7.88543 7.45999 7.88984 7.46087 7.8947C7.46175
                7.89956 7.46091 7.90457 7.45848 7.90887C7.31107 8.17685 7.43775
                8.56174 7.64919 8.77414L7.65021 8.77518C7.67936 8.80419 7.71874
                8.82048 7.75977 8.82049C7.8008 8.82051 7.84019 8.80425 7.86936
                8.77526L7.87047 8.77414C8.08184 8.56174 8.20858 8.17681 8.06119
                7.90882C8.05876 7.90451 8.05792 7.89951 8.0588 7.89464C8.05969
                7.88978 8.06223 7.88537 8.06601 7.88222C8.06978 7.87905 8.07455
                7.87731 8.07946 7.87731C8.08439 7.87731 8.08915 7.87905 8.09293
                7.88222L8.47243 8.28666C8.47783 8.29207 8.48211 8.29849 8.48504
                8.30556C8.48797 8.31263 8.48948 8.32021 8.48948 8.32785C8.48748
                8.52397 8.43229 8.71582 8.32985 8.88276C8.32753 8.88655 8.32645
                8.89098 8.32678 8.89541C8.32711 8.89986 8.32884 8.90408 8.33169
                8.90748C8.33457 8.91086 8.33842 8.91328 8.34272 8.91434C8.34702
                8.9154 8.35154 8.91507 8.35566 8.91339C8.43264 8.88085 8.50257
                8.83355 8.56156 8.77414C8.68245 8.65266 8.75042 8.48794 8.75052
                8.31616C8.75064 8.14437 8.68287 7.97956 8.56212 7.85795L7.7598
                7.05186L6.95744 7.85795C6.83672 7.97958 6.76897 8.14438 6.76908
                8.31616C6.76919 8.48794 6.83715 8.65266 6.95803 8.77414C7.01701
                8.83355 7.08696 8.88085 7.16395 8.91339C7.16805 8.91507 7.17258
                8.9154 7.17688 8.91434C7.18118 8.91328 7.18504 8.91088 7.1879
                8.90748C7.19076 8.90408 7.19248 8.89986 7.19281 8.89543C7.19314
                8.89099 7.19206 8.88656 7.18974 8.88277C7.08732 8.71582 7.03216
                8.52397 7.03019 8.32785C7.03019 8.32021 7.03169 8.31263 7.0346
                8.30557ZM7.47829 60.7697C7.43183 60.7697 7.38727 60.7512 7.35441
                60.7182C7.32156 60.6852 7.3031 60.6404 7.3031
                60.5937V60.0656H6.60233C6.50941 60.0656 6.42029 60.0285 6.35458
                59.9625C6.28887 59.8965 6.25195 59.807 6.25195
                59.7136V57.6013C6.25195 57.4059 6.40963 57.2493 6.60233
                57.2493H9.40539C9.49831 57.2493 9.58744 57.2864 9.65315
                57.3524C9.71885 57.4184 9.75577 57.5079 9.75577
                57.6013V59.7136C9.75577 59.807 9.71885 59.8965 9.65315
                59.9625C9.58744 60.0285 9.49831 60.0656 9.40539
                60.0656H8.33672L7.68852 60.7187C7.65348 60.7521 7.60968 60.7697
                7.56588 60.7697H7.47829ZM8.87982
                58.8335V58.4814H8.52943V58.8335H8.87982ZM8.17905
                58.8335V58.4814H7.82867V58.8335H8.17905ZM7.47829
                58.8335V58.4814H7.12791V58.8335H7.47829ZM38.1407
                58.4813H37.1725V57.5132L38.1407 58.4813ZM37.3485
                57.2491H35.9401C35.7447 57.2491 35.588 57.4058 35.588
                57.6012V60.4176C35.588 60.6112 35.7447 60.7696 35.9401
                60.7696H38.0527C38.1461 60.7696 38.2356 60.7325 38.3017
                60.6665C38.3677 60.6005 38.4048 60.5109 38.4048
                60.4176V58.3053L37.3485 57.2491ZM37.5246
                59.7135V60.0655H35.9401V59.7135H37.5246ZM38.0527
                59.0094V59.3614H35.9401V59.0094H38.0527ZM66.6069 57.2491C65.6433
                57.2491 64.855 58.0412 64.855 59.0094C64.855 59.9775 65.6433
                60.7696 66.6069 60.7696C67.5704 60.7696 68.3588 59.9775 68.3588
                59.0094C68.3588 58.0412 67.5704 57.2491 66.6069 57.2491ZM66.2565
                59.8895L65.3806 59.0094L65.6276 58.7612L66.2565 59.3913L67.5862
                58.0553L67.8332 58.3053L66.2565 59.8895ZM84
                6.02853H94V10.0475H84V6.02853ZM42 41H32V45H42V41Z"
                fill="white" />
              <path
                d="M98.9903 1.95581H0V0.21604C0 0.108525 0.087559 0.0205593
                0.194575 0.0205593H98.8054C98.9124 0.0205593 99 0.108525 99
                0.21604V1.95581H98.9903Z"
                fill="#E6E6E6" />
              <path
                d="M97.4629 0.938482L97.21 1.20238L97.0738
                1.05577V1.46628H97.4824L97.3365 1.31967L97.5894 1.06554L97.4629
                0.938482Z"
                fill="#333333" />
              <path
                d="M97.6282 1.02642L97.8811 0.772298L98.0173
                0.918909V0.5084H97.6185L97.7547 0.65501L97.5017 0.909135L97.6282
                1.02642Z"
                fill="#333333" />
              <path
                d="M0 1.96458H5.03951L6.09021 0.0684181C6.09994 0.0488701 6.1194
                0.0390961 6.12913 0.0390961H16.3249C16.3443 0.0390961 16.3541
                0.0488701 16.3638 0.0586441L17.434
                1.9548H98.9806V1.92548H17.4632L16.393 0.0390961C16.3833 0.019548
                16.3541 0 16.3346 0H6.12913C6.09994 0 6.08048 0.00977402 6.07076
                0.0390961L5.02005 1.94503H0V1.96458ZM0
                5.36594H98.9903V5.33661H0V5.36594Z"
                fill="#333333" />
              <path
                d="M17.4534 1.95699L16.3833 0.0608353C16.3735 0.0412872 16.3541
                0.0315132 16.3346 0.0315132H6.12913C6.10967 0.0315132 6.09021
                0.0412872 6.08048 0.0608353L5.02978
                1.95699H0V5.35835H98.9903V1.95699H17.4534Z"
                fill="#F2F2F2" />
              <path
                d="M5.20486 3.60665C5.17567 3.60665 5.15621 3.6262 5.15621
                3.65552C5.15621 3.75326 5.1173 3.84123 5.0492 3.90965C4.90327
                4.05626 4.6795 4.05626 4.53357 3.90965C4.38764 3.76304 4.38764
                3.53824 4.53357 3.39163C4.66005 3.26456 4.87408 3.25479 5.01028
                3.3623L4.90327 3.46982H5.1854V3.18637L5.07838 3.29389C4.89354
                3.1375 4.62113 3.14728 4.45574 3.32321C4.2709 3.50891 4.2709
                3.80213 4.45574 3.97807C4.5433 4.06603 4.66978 4.1149 4.78652
                4.1149C4.90327 4.1149 5.02001 4.06603 5.1173 3.97807C5.20486
                3.8901 5.2535 3.77281 5.2535 3.64575C5.26323 3.63598 5.23405
                3.60665 5.20486 3.60665Z"
                fill="#333333" />
              <path
                d="M3.10358 3.21552L3.01602 3.30349L3.31761
                3.59671H2.53931V3.72377H3.31761L3.01602 4.01699L3.10358
                4.10496L3.54137 3.65535L3.10358 3.21552Z"
                fill="#B3B3B3" />
              <path
                d="M1.49819 3.30518L1.41063 3.21721L0.972839 3.65705L1.41063
                4.10665L1.49819 4.01868L1.20633
                3.72546H1.9749V3.5984H1.20633L1.49819 3.30518Z"
                fill="#333333" />
              <path
                d="M95.4808 2.7487H6.46248C6.34573 2.7487 6.24844 2.84644
                6.24844 2.96373V4.37119C6.24844 4.48847 6.34573 4.58621 6.46248
                4.58621H95.4808C95.5975 4.58621 95.6948 4.48847 95.6948
                4.37119V2.95395C95.6948 2.83667 95.5975 2.7487 95.4808 2.7487Z"
                fill="white" />
              <path
                d="M95.4783 4.59378H6.45997C6.33349 4.59378 6.23621 4.50581
                6.23621 4.3983V2.9322C6.23621 2.82468 6.33349 2.73672 6.45997
                2.73672H95.4783C95.6047 2.73672 95.702 2.82468 95.702
                2.9322V4.3983C95.702 4.50581 95.6047 4.59378 95.4783
                4.59378ZM6.45997 2.75627C6.35295 2.75627 6.25566 2.83446 6.25566
                2.9322V4.3983C6.25566 4.49604 6.34322 4.57423 6.45997
                4.57423H95.4783C95.5853 4.57423 95.6826 4.49604 95.6826
                4.3983V2.9322C95.6826 2.83446 95.595 2.75627 95.4783
                2.75627H6.45997V2.75627Z"
                fill="#333333" />
              <path
                d="M97.9495 3.73294H96.7528C96.7139 3.73294 96.675 3.70376
                96.675 3.65512C96.675 3.61621 96.7042 3.5773 96.7528
                3.5773H97.9495C97.9884 3.5773 98.0273 3.60648 98.0273
                3.65512C98.0176 3.70376 97.9884 3.73294 97.9495 3.73294Z"
                fill="#333333" />
              <path
                d="M97.9504 3.342H96.7537C96.7148 3.342 96.6759 3.31282 96.6759
                3.26418C96.6759 3.22527 96.7051 3.18636 96.7537
                3.18636H97.9504C97.9893 3.18636 98.0282 3.21554 98.0282
                3.26418C98.0185 3.31282 97.9893 3.342 97.9504 3.342Z"
                fill="#333333" />
              <path
                d="M97.9495 4.12395H96.7528C96.7139 4.12395 96.675 4.09477
                96.675 4.04613C96.675 4.00722 96.7042 3.96831 96.7528
                3.96831H97.9495C97.9884 3.96831 98.0273 3.99749 98.0273
                4.04613C98.0176 4.09477 97.9884 4.12395 97.9495 4.12395Z"
                fill="#333333" />
              <path
                d="M16.0916 1.47588C16.3066 1.47588 16.4808 1.30084 16.4808
                1.08492C16.4808 0.868995 16.3066 0.693956 16.0916
                0.693956C15.8767 0.693956 15.7025 0.868995 15.7025
                1.08492C15.7025 1.30084 15.8767 1.47588 16.0916 1.47588Z"
                fill="#B3B3B3" />
              <path
                d="M4.12499 1.37812C4.33991 1.37812 4.51414 1.20309 4.51414
                0.987164C4.51414 0.771242 4.33991 0.596203 4.12499
                0.596203C3.91007 0.596203 3.73584 0.771242 3.73584
                0.987164C3.73584 1.20309 3.91007 1.37812 4.12499 1.37812Z"
                fill="#32A854" />
              <path
                d="M2.76299 1.37812C2.97791 1.37812 3.15214 1.20309 3.15214
                0.987164C3.15214 0.771242 2.97791 0.596203 2.76299
                0.596203C2.54807 0.596203 2.37384 0.771242 2.37384
                0.987164C2.37384 1.20309 2.54807 1.37812 2.76299 1.37812Z"
                fill="#FABC05" />
              <path
                d="M1.40093 1.37812C1.61585 1.37812 1.79008 1.20309 1.79008
                0.987164C1.79008 0.771242 1.61585 0.596203 1.40093
                0.596203C1.18601 0.596203 1.01178 0.771242 1.01178
                0.987164C1.01178 1.20309 1.18601 1.37812 1.40093 1.37812Z"
                fill="#EA4235" />
              <path
                d="M18.0469 0.938209H17.7648V0.654762C17.7648 0.62544 17.7453
                0.605892 17.7162 0.605892C17.687 0.605892 17.6675 0.62544
                17.6675 0.654762V0.938209H17.3854C17.3562 0.938209 17.3367
                0.957757 17.3367 0.987079C17.3367 1.0164 17.3562 1.03595 17.3854
                1.03595H17.6675V1.3194C17.6675 1.34872 17.687 1.36827 17.7162
                1.36827C17.7453 1.36827 17.7648 1.34872 17.7648
                1.3194V1.03595H18.0469C18.0761 1.03595 18.0956 1.0164 18.0956
                0.987079C18.0956 0.957757 18.0761 0.938209 18.0469 0.938209Z"
                fill="#333333" />
              <rect
                x="6.4812"
                y="63.2603"
                width="22.5065"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6.4812"
                y="65.6934"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6.4812"
                y="68.1265"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6.4812"
                y="70.5596"
                width="18.3043"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="63.1887"
                width="22.5065"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="65.6218"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="68.0547"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="70.488"
                width="18.3043"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="63.1887"
                width="22.5065"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="65.6218"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="68.0547"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="70.488"
                width="18.3043"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6"
                y="41.1948"
                width="26"
                height="4.01901"
                fill="white" />
              <rect
                x="75.236"
                y="7.08477"
                width="5.12806"
                height="1.71747"
                fill="#C4C4C4" />
              <rect
                x="66.6179"
                y="7.08477"
                width="5.12806"
                height="1.71747"
                fill="#C4C4C4" />
              <rect
                x="58"
                y="7.08477"
                width="5.12806"
                height="1.71747"
                fill="#C4C4C4" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M67 11.0523H0V52.2471H33.5465H67V11.0523ZM42 41H32V45H42V41Z"
                fill="url(#paint21_linear)" />
              <rect x="6" y="41" width="26" height="4" fill="white" />
              <rect x="6" y="23" width="37" height="3" fill="white" />
              <rect x="6" y="28" width="19" height="3" fill="white" />
              <rect x="6" y="35" width="38" height="1" fill="#DADADA" />
              <rect x="6" y="37" width="31" height="1" fill="#DADADA" />
              <path
                d="M55.7394 45.1234C54.3833 45.1234 53.0269 44.9436 51.7085
                44.5949H72.8397H93.9653C92.6523 44.9436 91.2948 45.1234 89.9311
                45.1234H72.8397H55.7394Z"
                fill="white"
                stroke="black"
                stroke-width="0.2" />
              <path
                d="M90.6912
                44.1394V44.1925H90.5321H55.1379H54.9787V44.1394H90.6912Z"
                fill="black" />
              <rect
                x="55.7421"
                y="21.3173"
                width="34.1152"
                height="21.69"
                fill="white" />
              <path
                d="M89.8298
                42.9449H89.9298V42.8449V21.5223V21.4223H89.8298H55.8403H55.7403V21.5223V42.8449V42.9449H55.8403H89.8298ZM56.0351
                20.208H89.6349C90.0895 20.208 90.465 20.5936 90.465
                21.0786V44.1158H90.403H90.3222H90.2416H90.161H90.0807H90.0004H89.9203H89.8403H89.7605H89.6808H89.6012H89.5218H89.4424H89.3633H89.2842H89.2053H89.1265H89.0479H88.9693H88.8909H88.8127H88.7345H88.6565H88.5786H88.5008H88.4232H88.3457H88.2683H88.191H88.1139H88.0368H87.9599H87.8832H87.8065H87.73H87.6535H87.5772H87.5011H87.425H87.349H87.2732H87.1975H87.1219H87.0464H86.971H86.8958H86.8207H86.7456H86.6707H86.5959H86.5212H86.4466H86.3722H86.2978H86.2236H86.1494H86.0754H86.0015H85.9276H85.8539H85.7803H85.7068H85.6334H85.5601H85.487H85.4139H85.3409H85.268H85.1952H85.1226H85.05H84.9775H84.9051H84.8329H84.7607H84.6886H84.6166H84.5447H84.473H84.4013H84.3297H84.2582H84.1867H84.1154H84.0442H83.9731H83.902H83.8311H83.7602H83.6895H83.6188H83.5482H83.4777H83.4073H83.337H83.2667H83.1966H83.1265H83.0566H82.9867H82.9168H82.8471H82.7775H82.7079H82.6384H82.5691H82.4997H82.4305H82.3614H82.2923H82.2233H82.1544H82.0855H82.0168H81.9481H81.8795H81.8109H81.7425H81.6741H81.6058H81.5375H81.4694H81.4013H81.3333H81.2653H81.1974H81.1296H81.0619H80.9942H80.9266H80.8591H80.7916H80.7242H80.6569H80.5896H80.5224H80.4553H80.3882H80.3212H80.2543H80.1874H80.1206H80.0538H79.9871H79.9205H79.8539H79.7874H79.7209H79.6545H79.5882H79.5219H79.4557H79.3895H79.3234H79.2573H79.1913H79.1253H79.0594H78.9936H78.9278H78.8621H78.7964H78.7307H78.6651H78.5996H78.5341H78.4686H78.4032H78.3379H78.2726H78.2073H78.1421H78.0769H78.0118H77.9467H77.8817H77.8167H77.7518H77.6869H77.622H77.5572H77.4924H77.4276H77.3629H77.2983H77.2336H77.169H77.1045H77.04H76.9755H76.911H76.8466H76.7822H76.7179H76.6536H76.5893H76.5251H76.4608H76.3967H76.3325H76.2684H76.2043H76.1402H76.0762H76.0122H75.9482H75.8842H75.8203H75.7564H75.6925H75.6287H75.5648H75.501H75.4372H75.3735H75.3097H75.246H75.1823H75.1186H75.055H74.9913H74.9277H74.8641H74.8005H74.737H74.6734H74.6099H74.5463H74.4828H74.4193H74.3559H74.2924H74.2289H74.1655H74.1021H74.0386H73.9752H73.9118H73.8484H73.7851H73.7217H73.6583H73.595H73.5316H73.4683H73.4049H73.3416H73.2783H73.2149H73.1516H73.0883H73.025H72.9616H72.8983H72.835H72.7717H72.7084H72.6451H72.5817H72.5184H72.4551H72.3918H72.3284H72.2651H72.2018H72.1384H72.0751H72.0117H71.9483H71.885H71.8216H71.7582H71.6948H71.6314H71.568H71.5045H71.4411H71.3776H71.3142H71.2507H71.1872H71.1237H71.0602H70.9966H70.9331H70.8695H70.8059H70.7423H70.6787H70.615H70.5514H70.4877H70.424H70.3603H70.2966H70.2328H70.169H70.1052H70.0414H69.9775H69.9136H69.8497H69.7858H69.7218H69.6579H69.5938H69.5298H69.4657H69.4016H69.3375H69.2734H69.2092H69.145H69.0807H69.0164H68.9521H68.8878H68.8234H68.759H68.6945H68.6301H68.5655H68.501H68.4364H68.3718H68.3071H68.2424H68.1776H68.1129H68.048H67.9832H67.9183H67.8533H67.7883H67.7233H67.6582H67.5931H67.5279H67.4627H67.3974H67.3321H67.2668H67.2014H67.1359H67.0704H67.0049H66.9393H66.8737H66.808H66.7422H66.6764H66.6106H66.5447H66.4787H66.4127H66.3466H66.2805H66.2144H66.1481H66.0818H66.0155H65.9491H65.8826H65.8161H65.7495H65.6829H65.6162H65.5494H65.4826H65.4157H65.3488H65.2818H65.2147H65.1476H65.0804H65.0131H64.9458H64.8784H64.8109H64.7434H64.6758H64.6081H64.5404H64.4726H64.4047H64.3368H64.2687H64.2006H64.1325H64.0642H63.9959H63.9275H63.8591H63.7906H63.7219H63.6533H63.5845H63.5157H63.4467H63.3777H63.3087H63.2395H63.1703H63.101H63.0316H62.9621H62.8925H62.8229H62.7532H62.6834H62.6135H62.5435H62.4734H62.4033H62.333H62.2627H62.1923H62.1218H62.0512H61.9806H61.9098H61.8389H61.768H61.6969H61.6258H61.5546H61.4833H61.4119H61.3404H61.2688H61.1971H61.1253H61.0534H60.9814H60.9093H60.8372H60.7649H60.6925H60.62H60.5475H60.4748H60.402H60.3291H60.2561H60.1831H60.1099H60.0366H59.9632H59.8897H59.8161H59.7424H59.6686H59.5946H59.5206H59.4465H59.3722H59.2978H59.2234H59.1488H59.0741H58.9993H58.9244H58.8494H58.7742H58.699H58.6236H58.5481H58.4725H58.3968H58.321H58.245H58.169H58.0928H58.0165H57.9401H57.8635H57.7869H57.7101H57.6332H57.5562H57.479H57.4017H57.3244H57.2468H57.1692H57.0914H57.0135H56.9355H56.8574H56.7791H56.7007H56.6222H56.5435H56.4647H56.3858H56.3068H56.2276H56.1483H56.0688H55.9893H55.9095H55.8297H55.7497H55.6696H55.5894H55.509H55.4285H55.3478H55.267H55.205V21.0786C55.205
                20.5936 55.5806 20.208 56.0351 20.208Z"
                fill="white"
                stroke="black"
                stroke-width="0.2" />
              <rect
                x="51.1"
                y="44.1833"
                width="43.4414"
                height="0.365791"
                fill="white"
                stroke="black"
                stroke-width="0.2" />
              <defs>
                <linearGradient
                  id="paint21_linear"
                  x1="-3.52194e-07"
                  y1="31.1473"
                  x2="66"
                  y2="31.1473"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#404040" />
                  <stop offset="1" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <p>Clean Dark</p>

        </div>
        <div class="w-1/3" on:click={(model.pageStyle = 2)}>
          <div style="background-color:{model.colors.default}">

            <svg class="w-full h-full" viewBox="0 0 99 77" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M99 5.29543H0V11H99L99 5.29543ZM0 77V52H49.5688H99L99
                77H0ZM8.86778 7.55395L8.86601 7.55218L8.86568 7.55179L7.7598
                6.44063L6.65393 7.55176L6.6536 7.55215L6.65178 7.55393C6.48268
                7.72479 6.37527 7.94754 6.34663 8.18678C6.31799 8.42602 6.36976
                8.66801 6.49371 8.87429C6.61766 9.08058 6.80668 9.23931 7.03072
                9.32525C7.25476 9.41119 7.50097 9.41943 7.7302 9.34862C7.74949
                9.3427 7.7701 9.3427 7.7894 9.34862C8.01861 9.4194 8.2648
                9.41116 8.48882 9.32521C8.71285 9.23925 8.90185 9.08053 9.0258
                8.87426C9.14974 8.66799 9.20152 8.42602 9.17289 8.18679C9.14426
                7.94757 9.03686 7.72482 8.86778 7.55395ZM7.04716 8.28668C7.04178
                8.29208 7.03751 8.29851 7.0346 8.30557C7.03169 8.31263 7.03019
                8.32021 7.03019 8.32785C7.03216 8.52396 7.08732 8.71581 7.18974
                8.88277C7.19206 8.88656 7.19314 8.89099 7.19281 8.89543C7.19248
                8.89986 7.19076 8.90408 7.1879 8.90748C7.18504 8.91088 7.18118
                8.91327 7.17688 8.91433C7.17258 8.9154 7.16805 8.91507 7.16395
                8.91339C7.08696 8.88085 7.01701 8.83355 6.95803 8.77413C6.83715
                8.65266 6.76919 8.48794 6.76908 8.31616C6.76897 8.14438 6.83672
                7.97958 6.95744 7.85795L7.7598 7.05185L8.56212 7.85795C8.68287
                7.97956 8.75064 8.14437 8.75052 8.31616C8.75042 8.48794 8.68245
                8.65266 8.56156 8.77413C8.50257 8.83355 8.43264 8.88085 8.35566
                8.91339C8.35154 8.91507 8.34702 8.9154 8.34272 8.91433C8.33842
                8.91327 8.33457 8.91086 8.33169 8.90748C8.32884 8.90408 8.32711
                8.89986 8.32678 8.89541C8.32645 8.89098 8.32753 8.88654 8.32985
                8.88276C8.43229 8.71581 8.48748 8.52396 8.48948 8.32785C8.48948
                8.32021 8.48797 8.31263 8.48504 8.30556C8.48211 8.29848 8.47783
                8.29207 8.47243 8.28666L8.09293 7.88222C8.08915 7.87905 8.08439
                7.87731 8.07946 7.87731C8.07455 7.87731 8.06978 7.87905 8.06601
                7.88222C8.06223 7.88537 8.05969 7.88978 8.0588 7.89464C8.05792
                7.8995 8.05876 7.90451 8.06119 7.90882C8.20858 8.17681 8.08184
                8.56174 7.87047 8.77413L7.86936 8.77525C7.84019 8.80425 7.8008
                8.8205 7.75977 8.82049C7.71874 8.82048 7.67936 8.80419 7.65021
                8.77518L7.64919 8.77413C7.43775 8.56174 7.31107 8.17685 7.45848
                7.90887C7.46091 7.90457 7.46175 7.89956 7.46087 7.8947C7.45999
                7.88983 7.45744 7.88543 7.45366 7.88227C7.44988 7.8791 7.44512
                7.87737 7.4402 7.87737C7.43528 7.87737 7.43052 7.8791 7.42674
                7.88227L7.04716 8.28668ZM7.35441 60.7182C7.38727 60.7512 7.43183
                60.7697 7.47829 60.7697H7.56588C7.60968 60.7697 7.65348 60.7521
                7.68852 60.7187L8.33672 60.0656H9.40539C9.49831 60.0656 9.58744
                60.0285 9.65315 59.9625C9.71885 59.8965 9.75577 59.807 9.75577
                59.7136V57.6013C9.75577 57.5079 9.71885 57.4184 9.65315
                57.3524C9.58744 57.2864 9.49831 57.2493 9.40539
                57.2493H6.60233C6.40963 57.2493 6.25195 57.4059 6.25195
                57.6013V59.7136C6.25195 59.807 6.28887 59.8965 6.35458
                59.9625C6.42029 60.0285 6.50941 60.0656 6.60233
                60.0656H7.3031V60.5937C7.3031 60.6404 7.32156 60.6852 7.35441
                60.7182ZM8.87982
                58.4814V58.8335H8.52943V58.4814H8.87982ZM8.17905
                58.4814V58.8335H7.82867V58.4814H8.17905ZM7.47829
                58.4814V58.8335H7.12791V58.4814H7.47829ZM37.1725
                58.4813H38.1407L37.1725 57.5132V58.4813ZM35.9401
                57.2491H37.3485L38.4048 58.3053V60.4176C38.4048 60.5109 38.3677
                60.6005 38.3017 60.6665C38.2356 60.7325 38.1461 60.7696 38.0527
                60.7696H35.9401C35.7447 60.7696 35.588 60.6112 35.588
                60.4176V57.6012C35.588 57.4058 35.7447 57.2491 35.9401
                57.2491ZM37.5246
                60.0655V59.7135H35.9401V60.0655H37.5246ZM38.0527
                59.3614V59.0094H35.9401V59.3614H38.0527ZM64.855 59.0094C64.855
                58.0412 65.6433 57.2491 66.6069 57.2491C67.5704 57.2491 68.3588
                58.0412 68.3588 59.0094C68.3588 59.9775 67.5704 60.7696 66.6069
                60.7696C65.6433 60.7696 64.855 59.9775 64.855 59.0094ZM65.3806
                59.0094L66.2565 59.8895L67.8332 58.3053L67.5862 58.0553L66.2565
                59.3913L65.6276 58.7612L65.3806 59.0094ZM94
                6.02852H84V10.0475H94V6.02852Z"
                fill="white" />
              <path
                d="M98.9903 1.95582H0V0.216042C0 0.108527 0.087559 0.0205612
                0.194575 0.0205612H98.8054C98.9124 0.0205612 99 0.108527 99
                0.216042V1.95582H98.9903Z"
                fill="#E6E6E6" />
              <path
                d="M97.4629 0.93848L97.21 1.20238L97.0738
                1.05577V1.46628H97.4824L97.3365 1.31967L97.5894 1.06554L97.4629
                0.93848Z"
                fill="#333333" />
              <path
                d="M97.6282 1.02642L97.8811 0.772298L98.0173
                0.918909V0.5084H97.6185L97.7547 0.65501L97.5017 0.909135L97.6282
                1.02642Z"
                fill="#333333" />
              <path
                d="M0 1.96458H5.03951L6.09021 0.0684181C6.09994 0.0488701 6.1194
                0.0390961 6.12913 0.0390961H16.3249C16.3443 0.0390961 16.3541
                0.0488701 16.3638 0.0586441L17.434
                1.9548H98.9806V1.92548H17.4632L16.393 0.0390961C16.3833 0.019548
                16.3541 0 16.3346 0H6.12913C6.09994 0 6.08048 0.00977402 6.07076
                0.0390961L5.02005 1.94503H0V1.96458ZM0
                5.36594H98.9903V5.33661H0V5.36594Z"
                fill="#333333" />
              <path
                d="M17.4534 1.95699L16.3833 0.0608353C16.3735 0.0412872 16.3541
                0.0315132 16.3346 0.0315132H6.12913C6.10967 0.0315132 6.09021
                0.0412872 6.08048 0.0608353L5.02978
                1.95699H0V5.35835H98.9903V1.95699H17.4534Z"
                fill="#F2F2F2" />
              <path
                d="M5.20486 3.60666C5.17567 3.60666 5.15621 3.6262 5.15621
                3.65553C5.15621 3.75327 5.1173 3.84123 5.0492 3.90965C4.90327
                4.05626 4.6795 4.05626 4.53357 3.90965C4.38764 3.76304 4.38764
                3.53824 4.53357 3.39163C4.66005 3.26457 4.87408 3.25479 5.01028
                3.36231L4.90327 3.46982H5.1854V3.18637L5.07838 3.29389C4.89354
                3.1375 4.62113 3.14728 4.45574 3.32321C4.2709 3.50892 4.2709
                3.80214 4.45574 3.97807C4.5433 4.06603 4.66978 4.11491 4.78652
                4.11491C4.90327 4.11491 5.02001 4.06603 5.1173 3.97807C5.20486
                3.8901 5.2535 3.77281 5.2535 3.64575C5.26323 3.63598 5.23405
                3.60666 5.20486 3.60666Z"
                fill="#333333" />
              <path
                d="M3.10358 3.21552L3.01602 3.30349L3.31761
                3.59671H2.53931V3.72377H3.31761L3.01602 4.01699L3.10358
                4.10496L3.54137 3.65535L3.10358 3.21552Z"
                fill="#B3B3B3" />
              <path
                d="M1.49819 3.30518L1.41063 3.21722L0.972839 3.65705L1.41063
                4.10665L1.49819 4.01869L1.20633
                3.72547H1.9749V3.5984H1.20633L1.49819 3.30518Z"
                fill="#333333" />
              <path
                d="M95.4808 2.7487H6.46248C6.34573 2.7487 6.24844 2.84644
                6.24844 2.96373V4.37119C6.24844 4.48847 6.34573 4.58621 6.46248
                4.58621H95.4808C95.5975 4.58621 95.6948 4.48847 95.6948
                4.37119V2.95395C95.6948 2.83667 95.5975 2.7487 95.4808 2.7487Z"
                fill="white" />
              <path
                d="M95.4783 4.59378H6.45997C6.33349 4.59378 6.23621 4.50581
                6.23621 4.3983V2.9322C6.23621 2.82468 6.33349 2.73672 6.45997
                2.73672H95.4783C95.6047 2.73672 95.702 2.82468 95.702
                2.9322V4.3983C95.702 4.50581 95.6047 4.59378 95.4783
                4.59378ZM6.45997 2.75627C6.35295 2.75627 6.25566 2.83446 6.25566
                2.9322V4.3983C6.25566 4.49604 6.34322 4.57423 6.45997
                4.57423H95.4783C95.5853 4.57423 95.6826 4.49604 95.6826
                4.3983V2.9322C95.6826 2.83446 95.595 2.75627 95.4783
                2.75627H6.45997V2.75627Z"
                fill="#333333" />
              <path
                d="M97.9495 3.73294H96.7528C96.7139 3.73294 96.675 3.70376
                96.675 3.65512C96.675 3.61621 96.7042 3.5773 96.7528
                3.5773H97.9495C97.9884 3.5773 98.0273 3.60648 98.0273
                3.65512C98.0176 3.70376 97.9884 3.73294 97.9495 3.73294Z"
                fill="#333333" />
              <path
                d="M97.9504 3.342H96.7537C96.7148 3.342 96.6759 3.31282 96.6759
                3.26418C96.6759 3.22527 96.7051 3.18636 96.7537
                3.18636H97.9504C97.9893 3.18636 98.0282 3.21554 98.0282
                3.26418C98.0185 3.31282 97.9893 3.342 97.9504 3.342Z"
                fill="#333333" />
              <path
                d="M97.9495 4.12395H96.7528C96.7139 4.12395 96.675 4.09477
                96.675 4.04613C96.675 4.00721 96.7042 3.9683 96.7528
                3.9683H97.9495C97.9884 3.9683 98.0273 3.99749 98.0273
                4.04613C98.0176 4.09477 97.9884 4.12395 97.9495 4.12395Z"
                fill="#333333" />
              <path
                d="M16.0916 1.47588C16.3066 1.47588 16.4808 1.30084 16.4808
                1.08492C16.4808 0.868994 16.3066 0.693954 16.0916
                0.693954C15.8767 0.693954 15.7025 0.868994 15.7025
                1.08492C15.7025 1.30084 15.8767 1.47588 16.0916 1.47588Z"
                fill="#B3B3B3" />
              <path
                d="M4.12499 1.37812C4.33991 1.37812 4.51414 1.20309 4.51414
                0.987164C4.51414 0.771242 4.33991 0.596203 4.12499
                0.596203C3.91007 0.596203 3.73584 0.771242 3.73584
                0.987164C3.73584 1.20309 3.91007 1.37812 4.12499 1.37812Z"
                fill="#32A854" />
              <path
                d="M2.76299 1.37812C2.97791 1.37812 3.15214 1.20309 3.15214
                0.987164C3.15214 0.771242 2.97791 0.596203 2.76299
                0.596203C2.54807 0.596203 2.37384 0.771242 2.37384
                0.987164C2.37384 1.20309 2.54807 1.37812 2.76299 1.37812Z"
                fill="#FABC05" />
              <path
                d="M1.40093 1.37812C1.61585 1.37812 1.79008 1.20309 1.79008
                0.987164C1.79008 0.771242 1.61585 0.596203 1.40093
                0.596203C1.18601 0.596203 1.01178 0.771242 1.01178
                0.987164C1.01178 1.20309 1.18601 1.37812 1.40093 1.37812Z"
                fill="#EA4235" />
              <path
                d="M18.0469 0.938209H17.7648V0.654762C17.7648 0.62544 17.7453
                0.605892 17.7162 0.605892C17.687 0.605892 17.6675 0.62544
                17.6675 0.654762V0.938209H17.3854C17.3562 0.938209 17.3367
                0.957757 17.3367 0.987079C17.3367 1.0164 17.3562 1.03595 17.3854
                1.03595H17.6675V1.3194C17.6675 1.34872 17.687 1.36827 17.7162
                1.36827C17.7453 1.36827 17.7648 1.34872 17.7648
                1.3194V1.03595H18.0469C18.0761 1.03595 18.0956 1.0164 18.0956
                0.987079C18.0956 0.957757 18.0761 0.938209 18.0469 0.938209Z"
                fill="#333333" />
              <rect
                x="6.4812"
                y="63.2603"
                width="22.5065"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6.4812"
                y="65.6934"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6.4812"
                y="68.1265"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="6.4812"
                y="70.5596"
                width="18.3043"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="63.1887"
                width="22.5065"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="65.6218"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="68.0547"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="35.6115"
                y="70.488"
                width="18.3043"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="63.1887"
                width="22.5065"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="65.6218"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="68.0547"
                width="22.2928"
                height="1.07342"
                fill="#C6C6C5" />
              <rect
                x="64.8842"
                y="70.488"
                width="18.3043"
                height="1.07342"
                fill="#C6C6C5" />
              <rect x="6.00006" y="41" width="25" height="4" fill="white" />
              <rect x="31.0001" y="41" width="10" height="4" fill="#242424" />
              <rect
                x="75.236"
                y="7.08478"
                width="5.12806"
                height="1.71747"
                fill="#C4C4C4" />
              <rect
                x="66.6179"
                y="7.08478"
                width="5.12806"
                height="1.71747"
                fill="#C4C4C4" />
              <rect
                x="58"
                y="7.08478"
                width="5.12806"
                height="1.71747"
                fill="#C4C4C4" />
              <rect x="6" y="23" width="35" height="3" fill="white" />
              <rect x="6" y="28" width="18" height="3" fill="white" />
              <rect x="6" y="35" width="35" height="1" fill="#DADADA" />
              <rect x="6" y="37" width="29" height="1" fill="#DADADA" />
              <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="43"
                y="11"
                width="56"
                height="41">
                <rect
                  x="43.0001"
                  y="11"
                  width="56"
                  height="41"
                  fill="#C4C4C4" />
              </mask>
              <g mask="url(#mask0)">
                <circle
                  cx="96.7479"
                  cy="20.7478"
                  r="3.95644"
                  transform="rotate(-60 96.7479 20.7478)"
                  fill="white" />
                <circle
                  cx="96.7464"
                  cy="41.7353"
                  r="0.99022"
                  transform="rotate(12.5856 96.7464 41.7353)"
                  fill="white" />
                <circle
                  cx="91.1957"
                  cy="38.6708"
                  r="0.99022"
                  transform="rotate(12.5856 91.1957 38.6708)"
                  fill="white" />
                <circle
                  cx="93.5663"
                  cy="12.6515"
                  r="0.99022"
                  transform="rotate(12.5856 93.5663 12.6515)"
                  fill="white" />
                <circle
                  cx="92.9548"
                  cy="50.2594"
                  r="5.66644"
                  transform="rotate(-60 92.9548 50.2594)"
                  fill="white" />
                <circle
                  cx="87.0192"
                  cy="11.0192"
                  r="2.21018"
                  transform="rotate(-60 87.0192 11.0192)"
                  fill="white" />
                <circle
                  cx="95.9815"
                  cy="31.8347"
                  r="2.21018"
                  transform="rotate(-60 95.9815 31.8347)"
                  fill="white" />
                <circle
                  cx="47.4046"
                  cy="38.252"
                  r="3.95644"
                  transform="rotate(120 47.4046 38.252)"
                  fill="white" />
                <circle
                  cx="47.4061"
                  cy="17.2646"
                  r="0.99022"
                  transform="rotate(-167.414 47.4061 17.2646)"
                  fill="white" />
                <circle
                  cx="52.9569"
                  cy="20.3291"
                  r="0.99022"
                  transform="rotate(-167.414 52.9569 20.3291)"
                  fill="white" />
                <circle
                  cx="50.5862"
                  cy="46.3484"
                  r="0.99022"
                  transform="rotate(-167.414 50.5862 46.3484)"
                  fill="white" />
                <circle
                  cx="51.1977"
                  cy="8.74044"
                  r="5.66644"
                  transform="rotate(120 51.1977 8.74044)"
                  fill="white" />
                <circle
                  cx="57.1333"
                  cy="47.9807"
                  r="2.21018"
                  transform="rotate(120 57.1333 47.9807)"
                  fill="white" />
                <circle
                  cx="48.1711"
                  cy="27.1652"
                  r="2.21018"
                  transform="rotate(120 48.1711 27.1652)"
                  fill="white" />
              </g>
              <path
                d="M55.7394 45.1233C54.3833 45.1233 53.0269 44.9435 51.7085
                44.5948H72.8397H93.9653C92.6523 44.9435 91.2948 45.1233 89.9311
                45.1233H72.8397H55.7394Z"
                fill="white"
                stroke="black"
                stroke-width="0.2" />
              <path
                d="M90.6912
                44.1394V44.1924H90.5321H55.1379H54.9787V44.1394H90.6912Z"
                fill="black" />
              <rect
                x="55.7421"
                y="21.3173"
                width="34.1152"
                height="21.69"
                fill="#242424" />
              <path
                d="M89.8298
                42.9449H89.9298V42.8449V21.5222V21.4222H89.8298H55.8403H55.7403V21.5222V42.8449V42.9449H55.8403H89.8298ZM56.0351
                20.2079H89.6349C90.0895 20.2079 90.465 20.5936 90.465
                21.0785V44.1158H90.403H90.3222H90.2416H90.161H90.0807H90.0004H89.9203H89.8403H89.7605H89.6808H89.6012H89.5218H89.4424H89.3633H89.2842H89.2053H89.1265H89.0479H88.9693H88.8909H88.8127H88.7345H88.6565H88.5786H88.5008H88.4232H88.3457H88.2683H88.191H88.1139H88.0368H87.9599H87.8832H87.8065H87.73H87.6535H87.5772H87.5011H87.425H87.349H87.2732H87.1975H87.1219H87.0464H86.971H86.8958H86.8207H86.7456H86.6707H86.5959H86.5212H86.4466H86.3722H86.2978H86.2236H86.1494H86.0754H86.0015H85.9276H85.8539H85.7803H85.7068H85.6334H85.5601H85.487H85.4139H85.3409H85.268H85.1952H85.1226H85.05H84.9775H84.9051H84.8329H84.7607H84.6886H84.6166H84.5447H84.473H84.4013H84.3297H84.2582H84.1867H84.1154H84.0442H83.9731H83.902H83.8311H83.7602H83.6895H83.6188H83.5482H83.4777H83.4073H83.337H83.2667H83.1966H83.1265H83.0566H82.9867H82.9168H82.8471H82.7775H82.7079H82.6384H82.5691H82.4997H82.4305H82.3614H82.2923H82.2233H82.1544H82.0855H82.0168H81.9481H81.8795H81.8109H81.7425H81.6741H81.6058H81.5375H81.4694H81.4013H81.3333H81.2653H81.1974H81.1296H81.0619H80.9942H80.9266H80.8591H80.7916H80.7242H80.6569H80.5896H80.5224H80.4553H80.3882H80.3212H80.2543H80.1874H80.1206H80.0538H79.9871H79.9205H79.8539H79.7874H79.7209H79.6545H79.5882H79.5219H79.4557H79.3895H79.3234H79.2573H79.1913H79.1253H79.0594H78.9936H78.9278H78.8621H78.7964H78.7307H78.6651H78.5996H78.5341H78.4686H78.4032H78.3379H78.2726H78.2073H78.1421H78.0769H78.0118H77.9467H77.8817H77.8167H77.7518H77.6869H77.622H77.5572H77.4924H77.4276H77.3629H77.2983H77.2336H77.169H77.1045H77.04H76.9755H76.911H76.8466H76.7822H76.7179H76.6536H76.5893H76.5251H76.4608H76.3967H76.3325H76.2684H76.2043H76.1402H76.0762H76.0122H75.9482H75.8842H75.8203H75.7564H75.6925H75.6287H75.5648H75.501H75.4372H75.3735H75.3097H75.246H75.1823H75.1186H75.055H74.9913H74.9277H74.8641H74.8005H74.737H74.6734H74.6099H74.5463H74.4828H74.4193H74.3559H74.2924H74.2289H74.1655H74.1021H74.0386H73.9752H73.9118H73.8484H73.7851H73.7217H73.6583H73.595H73.5316H73.4683H73.4049H73.3416H73.2783H73.2149H73.1516H73.0883H73.025H72.9616H72.8983H72.835H72.7717H72.7084H72.6451H72.5817H72.5184H72.4551H72.3918H72.3284H72.2651H72.2018H72.1384H72.0751H72.0117H71.9483H71.885H71.8216H71.7582H71.6948H71.6314H71.568H71.5045H71.4411H71.3776H71.3142H71.2507H71.1872H71.1237H71.0602H70.9966H70.9331H70.8695H70.8059H70.7423H70.6787H70.615H70.5514H70.4877H70.424H70.3603H70.2966H70.2328H70.169H70.1052H70.0414H69.9775H69.9136H69.8497H69.7858H69.7218H69.6579H69.5938H69.5298H69.4657H69.4016H69.3375H69.2734H69.2092H69.145H69.0807H69.0164H68.9521H68.8878H68.8234H68.759H68.6945H68.6301H68.5655H68.501H68.4364H68.3718H68.3071H68.2424H68.1776H68.1129H68.048H67.9832H67.9183H67.8533H67.7883H67.7233H67.6582H67.5931H67.5279H67.4627H67.3974H67.3321H67.2668H67.2014H67.1359H67.0704H67.0049H66.9393H66.8737H66.808H66.7422H66.6764H66.6106H66.5447H66.4787H66.4127H66.3466H66.2805H66.2144H66.1481H66.0818H66.0155H65.9491H65.8826H65.8161H65.7495H65.6829H65.6162H65.5494H65.4826H65.4157H65.3488H65.2818H65.2147H65.1476H65.0804H65.0131H64.9458H64.8784H64.8109H64.7434H64.6758H64.6081H64.5404H64.4726H64.4047H64.3368H64.2687H64.2006H64.1325H64.0642H63.9959H63.9275H63.8591H63.7906H63.7219H63.6533H63.5845H63.5157H63.4467H63.3777H63.3087H63.2395H63.1703H63.101H63.0316H62.9621H62.8925H62.8229H62.7532H62.6834H62.6135H62.5435H62.4734H62.4033H62.333H62.2627H62.1923H62.1218H62.0512H61.9806H61.9098H61.8389H61.768H61.6969H61.6258H61.5546H61.4833H61.4119H61.3404H61.2688H61.1971H61.1253H61.0534H60.9814H60.9093H60.8372H60.7649H60.6925H60.62H60.5475H60.4748H60.402H60.3291H60.2561H60.1831H60.1099H60.0366H59.9632H59.8897H59.8161H59.7424H59.6686H59.5946H59.5206H59.4465H59.3722H59.2978H59.2234H59.1488H59.0741H58.9993H58.9244H58.8494H58.7742H58.699H58.6236H58.5481H58.4725H58.3968H58.321H58.245H58.169H58.0928H58.0165H57.9401H57.8635H57.7869H57.7101H57.6332H57.5562H57.479H57.4017H57.3244H57.2468H57.1692H57.0914H57.0135H56.9355H56.8574H56.7791H56.7007H56.6222H56.5435H56.4647H56.3858H56.3068H56.2276H56.1483H56.0688H55.9893H55.9095H55.8297H55.7497H55.6696H55.5894H55.509H55.4285H55.3478H55.267H55.205V21.0785C55.205
                20.5936 55.5806 20.2079 56.0351 20.2079Z"
                fill="white"
                stroke="black"
                stroke-width="0.2" />
              <rect
                x="51.1"
                y="44.1832"
                width="43.4414"
                height="0.365791"
                fill="white"
                stroke="black"
                stroke-width="0.2" />
            </svg>
          </div>
          <p>Round</p>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-8">
    <h2>Logo</h2>
    <FileSelect bind:model={model.logo} />
  </div>
  <div class="mt-8">
    <h2>Colors</h2>
    <div class="flex flex-row">
      <div class="w-1/3">
        <p>Primary</p>
        <div
          style="width:32px; height:32px; margin-top: 27px; margin-right:16px;
          background-color:{model.colors.default}" />
        <Input bind:model={model.colors.default} scheme="#" />
      </div>
      <div class="w-1/3">
        <p>Lighter</p>
        <div
          style="width:32px; height:32px; margin-top: 27px; margin-right:16px;
          background-color:{model.colors.light}" />
        <Input bind:model={model.colors.light} scheme="#" />
      </div>
      <div class="w-1/3">
        <p>Darker</p>
        <div
          style="width:32px; height:32px; margin-top: 27px; margin-right:16px;
          background-color:{model.colors.dark}" />
        <Input bind:model={model.colors.dark} scheme="#" />
      </div>
    </div>
  </div>
  <div class="mt-8">
    <h2>Fonts</h2>
    <div class="flex flex-row">
      <Input bind:model={model.fonts.title} label="Title" />
      <Input bind:model={model.fonts.body} label="Body" />
    </div>
  </div>
</div>
